import React, { Component } from "react";
import IndicatorSection from "./IndicatorSection";
import { propertyUtil } from "views/Pma/PropertyUtil";
import { isPdfPrintVersion } from "views/Pma/PmaEditor/CommonEditor/pdfPrintVersion";

class YETwoMarketIndicators extends Component {
  componentDidMount() {
    if (this.props.pdfPrintVersion || isPdfPrintVersion()) {
      require("./pdfprint.scss");
    } else if (this.props.printVersion) {
      require("./print.scss");
    } else {
      require("./editor.scss");
    }
  }
  determineComparison = () => {
    const { infinityCheck } = propertyUtil;
    function calculateDiff(curr, prev) {
      if (curr === "0" && prev === "0") {
        return "0";
      } else if (curr === "0") {
        return -100;
      } else if (prev === "0") {
        return 100;
      } else {
        curr = Math.round(curr);
        prev = Math.round(prev);
        let res = infinityCheck(
          Math.round(((curr - prev) / Math.abs(prev)) * 100),
        );
        return res;
      }
    }
    const {
      quarterlyAreaTable,
      currentArea,
      useCity,
      quarterlyCityTable,
      agentData,
      useSecondMarketIndicators,
      useSeparatedPropertyTypesCondoTownhouse,
      useSeparatedPropertyTypesCondos,
      useSeparatedPropertyTypesTownhouses,
    } = this.props;
    const { listgenUserID } = agentData;
    const { marketHighLightsData, marketTrends } = quarterlyAreaTable;

    const { keyMarketIndicatorAveragesForCity } = quarterlyCityTable;
    const { mlsAreaID } = currentArea;

    let dataObj = {
      compareDays: null,
      salePriceDiff: null,
      salePriceDataPoint: null,
      receivedPerc: null,
      receivedDataPoint: null,
      daysToSellPerc: null,
      daysToSellDataPoint: null,
      unitsSoldPerc: null,
      unitsSoldDataPoint: null,
      previousUnitsSoldDataPoint: null,
      sqftPercDiff: null,
      sqftDataPoint: null,
      monthComparison: null,
      highestSalePrice: null,
      useMedianSalePrice: false,
    };
    const {
      current180DaysAvgSalePrice,
      previous180DaysAvgSalePrice,
      current180DaysMedianSalePrice,
      previous180DaysMedianSalePrice,
      current180DaysPercentReceivedOfAsking,
      previous180DaysPercentReceivedOfAsking,
      current180DaysAvgDOM,
      previous180DaysAvgDOM,
      current180DaysUnitsSold,
      previous180DaysUnitsSold,
      current180DaysPricePerSqFt,
      previous180DaysPricePerSqFt,
      current90DaysMedianSalePrice,
      previous90DaysMedianSalePrice,
      median180DaysPercentage,
      current90DaysAvgSalePrice,
      previous90DaysAvgSalePrice,
      current90DaysPercentReceivedOfAsking,
      previous90DaysPercentReceivedOfAsking,
      current90DaysAvgDOM,
      previous90DaysAvgDOM,
      current90DaysUnitsSold,
      previous90DaysUnitsSold,
      current90DaysPricePerSqFt,
      previous90DaysPricePerSqFt,
      median12MonthsPercentage,
      last12MonthsAverageSalePrice,
      previous12MonthsAverageSalePrice,
      last12MonthsMedianSalePrice,
      previous12MonthsMedianSalePrice,
      last12MonthsPercentReceivedOfAsking,
      previous12MonthsPercentReceivedOfAsking,
      last12MonthsPricePerSqFt,
      previous12MonthsPricePerSqFt,
      previous12MonthsUnitsSold,
    } = marketHighLightsData;

    if (listgenUserID === "102548" || listgenUserID === "105227") {
      dataObj.useMedianSalePrice = true;
    }

    let use6Months = false;
    let use6MonthsVsLastYear6Months = true;

    let use12MonthComparison = false;
    if (
      listgenUserID === "102548" ||
      listgenUserID === "102660" ||
      listgenUserID === "104480"
    ) {
      use6MonthsVsLastYear6Months = false;
      use12MonthComparison = true;
    }

    if (useCity) {
      //if los olivos or Buellton

      const {
        keyMarketIndicatorAveragesForCity,
        keyMarketIndicatorAveragesPercentageForCity,
      } = quarterlyCityTable;
      let currSix = keyMarketIndicatorAveragesForCity.filter(
        (term) => term.NameOfTerm === "CurrentSixMonths",
      )[0];
      let prevSix = keyMarketIndicatorAveragesForCity.filter(
        (term) => term.NameOfTerm === "PreviousSixMonths",
      )[0];

      const {
        AverageDaysOnMarket: currAverageDaysOnMarket,
        AveragePercentOfReceiving: currAveragePercentOfReceiving,
        AveragePricePerSqFt: currAveragePricePerSqFt,
        AverageSalePrice: currAverageSalePrice,
        NameOfTerm: currNameOfTerm,
        NumberOfListings: currNumberOfListings,
      } = currSix;
      const {
        AverageDaysOnMarket: prevAverageDaysOnMarket,
        AveragePercentOfReceiving: prevAveragePercentOfReceiving,
        AveragePricePerSqFt: prevAveragePricePerSqFt,
        AverageSalePrice: prevAverageSalePrice,
        NameOfTerm: prevNameOfTerm,
        NumberOfListings: prevNumberOfListings,
      } = prevSix;

      dataObj.compareDays = "6 Months";
      dataObj.monthComparison = 6;
      dataObj.salePriceDataPoint = currAverageSalePrice;
      dataObj.salePriceDiff = calculateDiff(
        currAverageSalePrice,
        prevAverageSalePrice,
      );
      dataObj.receivedDataPoint = currAveragePercentOfReceiving;
      dataObj.receivedPerc = calculateDiff(
        currAveragePercentOfReceiving,
        prevAveragePercentOfReceiving,
      );
      dataObj.sqftDataPoint = currAveragePricePerSqFt;
      dataObj.sqftPercDiff = calculateDiff(
        currAveragePricePerSqFt,
        prevAveragePricePerSqFt,
      );
      dataObj.daysToSellDataPoint = currAverageDaysOnMarket;
      dataObj.daysToSellPerc = calculateDiff(
        currAverageDaysOnMarket,
        prevAverageDaysOnMarket,
      );
      dataObj.unitsSoldDataPoint = currNumberOfListings;
      dataObj.unitsSoldPerc = calculateDiff(
        currNumberOfListings,
        prevNumberOfListings,
      );

      return dataObj;
    }
    if (useSeparatedPropertyTypesTownhouses && mlsAreaID === "SMA-392") {
      // 6 month vs same 6 months last year Townhouses
      const {
        marketTrendsTH: marketTrendsArea,
        marketTrendsPercentageTH: marketTrendsPercArea,
      } = quarterlyAreaTable;

      let currentYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "6-Months Trending",
      )[0];

      let currentYearAreaPerc = marketTrendsPercArea.filter(
        (obj) => obj.TrendPercentageName === "Same 6 Months Trends Percentage",
      )[0];

      const pastYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "Same 6-Months Last Year Trending",
      )[0];

      dataObj.compareDays = "6MonthsVSLastYear6Months";
      dataObj.monthComparison = 6;

      dataObj.salePriceDataPoint = currentYearObjArea.AvgSalePrice;
      dataObj.salePriceDiff = currentYearAreaPerc
        ? currentYearAreaPerc.PercentageAvgSalePrice
        : calculateDiff(
            currentYearObjArea.AvgSalePrice,
            pastYearObjArea.AvgSalePrice,
          );

      dataObj.daysToSellDataPoint = currentYearObjArea.AvgDaysOnMarket;
      dataObj.receivedDataPoint = currentYearObjArea.AvgPercentOfReceiving;
      dataObj.receivedPerc = calculateDiff(
        currentYearObjArea.AvgPercentOfReceiving,
        pastYearObjArea.AvgPercentOfReceiving,
      );

      dataObj.daysToSellPerc = currentYearAreaPerc
        ? currentYearAreaPerc.PercentageAvgDaysOnMarket
        : calculateDiff(
            currentYearObjArea.AvgDaysOnMarket,
            pastYearObjArea.AvgDaysOnMarket,
          );

      dataObj.unitsSoldDataPoint = currentYearObjArea.HomesSold;
      dataObj.previousUnitsSoldDataPoint = pastYearObjArea.HomesSold;
      dataObj.unitsSoldPerc = currentYearAreaPerc
        ? currentYearAreaPerc.PercentageNumberOfHomesSold
        : calculateDiff(
            currentYearObjArea.HomesSold,
            pastYearObjArea.HomesSold,
          );

      dataObj.sqftDataPoint = currentYearObjArea.AvgPricePerSqFt;
      dataObj.sqftPercDiff = currentYearAreaPerc
        ? currentYearAreaPerc.PercentageAvgPricePerSqFt
        : calculateDiff(
            currentYearObjArea.AvgPricePerSqFt,
            pastYearObjArea.AvgPricePerSqFt,
          );

      return dataObj;
    } else if (
      useSeparatedPropertyTypesCondos &&
      (mlsAreaID === "SMA-392" || mlsAreaID === "CCA-4500F")
    ) {
      // 6 month vs same 6 months last year
      console.log("**inside 182");
      const {
        marketTrendsCND: marketTrendsArea,
        marketTrendsPercentageCND: marketTrendsPercArea,
      } = quarterlyAreaTable;
      console.log("quarterlyAreaTable", quarterlyAreaTable);
      let currentYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "6-Months Trending",
      )[0];

      let currentYearAreaPerc = marketTrendsPercArea.filter(
        (obj) => obj.TrendPercentageName === "Same 6 Months Trends Percentage",
      )[0];

      const pastYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "Same 6-Months Last Year Trending",
      )[0];

      console.log("currentYearObjArea", currentYearObjArea);
      console.log("pastYearObjArea", pastYearObjArea);

      dataObj.compareDays = "6MonthsVSLastYear6Months";
      dataObj.monthComparison = 6;

      dataObj.salePriceDataPoint = currentYearObjArea.AvgSalePrice;
      dataObj.salePriceDiff = currentYearAreaPerc
        ? currentYearAreaPerc.PercentageAvgSalePrice
        : calculateDiff(
            currentYearObjArea.AvgSalePrice,
            pastYearObjArea.AvgSalePrice,
          );

      dataObj.daysToSellDataPoint = currentYearObjArea.AvgDaysOnMarket;
      dataObj.receivedDataPoint = currentYearObjArea.AvgPercentOfReceiving;
      dataObj.receivedPerc = calculateDiff(
        currentYearObjArea.AvgPercentOfReceiving,
        pastYearObjArea.AvgPercentOfReceiving,
      );

      dataObj.daysToSellPerc = currentYearAreaPerc
        ? currentYearAreaPerc.PercentageAvgDaysOnMarket
        : calculateDiff(
            currentYearObjArea.AvgDaysOnMarket,
            pastYearObjArea.AvgDaysOnMarket,
          );

      dataObj.unitsSoldDataPoint = currentYearObjArea.HomesSold;
      dataObj.previousUnitsSoldDataPoint = pastYearObjArea.HomesSold;
      dataObj.unitsSoldPerc = currentYearAreaPerc
        ? currentYearAreaPerc.PercentageNumberOfHomesSold
        : calculateDiff(
            currentYearObjArea.HomesSold,
            pastYearObjArea.HomesSold,
          );

      dataObj.sqftDataPoint = currentYearObjArea.AvgPricePerSqFt;
      dataObj.sqftPercDiff = currentYearAreaPerc
        ? currentYearAreaPerc.PercentageAvgPricePerSqFt
        : calculateDiff(
            currentYearObjArea.AvgPricePerSqFt,
            pastYearObjArea.AvgPricePerSqFt,
          );

      return dataObj;
    } else if (
      useSeparatedPropertyTypesCondoTownhouse &&
      mlsAreaID === "SMA-392"
    ) {
      // 6 month vs same 6 months last year
      const {
        marketTrendsCNDTH: marketTrendsArea,
        marketTrendsPercentageCNDTH: marketTrendsPercArea,
      } = quarterlyAreaTable;

      let currentYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "6-Months Trending",
      )[0];

      let currentYearAreaPerc = marketTrendsPercArea.filter(
        (obj) => obj.TrendPercentageName === "Same 6 Months Trends Percentage",
      )[0];

      const pastYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "Same 6-Months Last Year Trending",
      )[0];

      dataObj.compareDays = "6MonthsVSLastYear6Months";
      dataObj.monthComparison = 6;

      dataObj.salePriceDataPoint = currentYearObjArea.AvgSalePrice;
      dataObj.salePriceDiff = currentYearAreaPerc
        ? currentYearAreaPerc.PercentageAvgSalePrice
        : calculateDiff(
            currentYearObjArea.AvgSalePrice,
            pastYearObjArea.AvgSalePrice,
          );

      dataObj.daysToSellDataPoint = currentYearObjArea.AvgDaysOnMarket;
      dataObj.receivedDataPoint = currentYearObjArea.AvgPercentOfReceiving;
      dataObj.receivedPerc = calculateDiff(
        currentYearObjArea.AvgPercentOfReceiving,
        pastYearObjArea.AvgPercentOfReceiving,
      );

      dataObj.daysToSellPerc = currentYearAreaPerc.PercentageAvgDaysOnMarket;

      dataObj.unitsSoldDataPoint = currentYearObjArea.HomesSold;
      dataObj.previousUnitsSoldDataPoint = pastYearObjArea.HomesSold;
      dataObj.unitsSoldPerc = currentYearAreaPerc.PercentageNumberOfHomesSold;

      dataObj.sqftDataPoint = currentYearObjArea.AvgPricePerSqFt;
      dataObj.sqftPercDiff = currentYearAreaPerc.PercentageAvgPricePerSqFt;

      return dataObj;
    } else if (
      !useSeparatedPropertyTypesCondoTownhouse &&
      !useSeparatedPropertyTypesCondos &&
      !useSeparatedPropertyTypesTownhouses &&
      mlsAreaID === "SMA-392"
    ) {
      // 6 month vs same 6 months last year
      const {
        marketTrendsSFR: marketTrendsArea,
        marketTrendsPercentageSFR: marketTrendsPercArea,
      } = quarterlyAreaTable;

      let currentYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "6-Months Trending",
      )[0];

      let currentYearAreaPerc = marketTrendsPercArea.filter(
        (obj) => obj.TrendPercentageName === "Same 6 Months Trends Percentage",
      )[0];

      const pastYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "Same 6-Months Last Year Trending",
      )[0];

      dataObj.compareDays = "6MonthsVSLastYear6Months";
      dataObj.monthComparison = 6;

      dataObj.salePriceDataPoint = currentYearObjArea.AvgSalePrice;
      dataObj.salePriceDiff = currentYearAreaPerc
        ? currentYearAreaPerc.PercentageAvgSalePrice
        : calculateDiff(
            currentYearObjArea.AvgSalePrice,
            pastYearObjArea.AvgSalePrice,
          );

      dataObj.daysToSellDataPoint = currentYearObjArea.AvgDaysOnMarket;
      dataObj.receivedDataPoint = currentYearObjArea.AvgPercentOfReceiving;
      dataObj.receivedPerc = calculateDiff(
        currentYearObjArea.AvgPercentOfReceiving,
        pastYearObjArea.AvgPercentOfReceiving,
      );

      dataObj.daysToSellPerc = currentYearAreaPerc.PercentageAvgDaysOnMarket;

      dataObj.unitsSoldDataPoint = currentYearObjArea.HomesSold;
      dataObj.previousUnitsSoldDataPoint = pastYearObjArea.HomesSold;
      dataObj.unitsSoldPerc = currentYearAreaPerc.PercentageNumberOfHomesSold;

      dataObj.sqftDataPoint = currentYearObjArea.AvgPricePerSqFt;
      dataObj.sqftPercDiff = currentYearAreaPerc.PercentageAvgPricePerSqFt;

      return dataObj;
    } else if (use6MonthsVsLastYear6Months) {
      // 6 month vs same 6 months last year
      const {
        marketTrends: marketTrendsArea,
        marketTrendsPercentage: marketTrendsPercArea,
        graphAverages: graphAveragesArea,
      } = quarterlyAreaTable;

      let currentYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "6-Months Trending",
      )[0];

      let currentYearAreaPerc = marketTrendsPercArea.filter(
        (obj) => obj.TrendPercentageName === "Same 6 Months Trends Percentage",
      )[0];

      if (!currentYearAreaPerc) {
      }
      const pastYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "Same 6-Months Last Year Trending",
      )[0];
      dataObj.compareDays = "6MonthsVSLastYear6Months";
      dataObj.monthComparison = 6;
      if (dataObj.useMedianSalePrice) {
        dataObj.salePriceDataPoint = current180DaysMedianSalePrice;
        dataObj.salePriceDiff = median180DaysPercentage;
      } else {
        dataObj.salePriceDataPoint = currentYearObjArea.AvgSalePrice;
        dataObj.salePriceDiff = currentYearAreaPerc
          ? currentYearAreaPerc.PercentageAvgSalePrice
          : calculateDiff(
              currentYearObjArea.AvgSalePrice,
              pastYearObjArea.AvgSalePrice,
            );
      }

      dataObj.daysToSellDataPoint = currentYearObjArea.AvgDaysOnMarket;
      dataObj.receivedDataPoint = currentYearObjArea.AvgPercentOfReceiving;
      dataObj.receivedPerc = calculateDiff(
        currentYearObjArea.AvgPercentOfReceiving,
        pastYearObjArea.AvgPercentOfReceiving,
      );

      dataObj.daysToSellPerc = currentYearAreaPerc.PercentageAvgDaysOnMarket;

      dataObj.unitsSoldDataPoint = currentYearObjArea.HomesSold;
      dataObj.previousUnitsSoldDataPoint = pastYearObjArea.HomesSold;
      dataObj.unitsSoldPerc = currentYearAreaPerc.PercentageNumberOfHomesSold;

      dataObj.sqftDataPoint = currentYearObjArea.AvgPricePerSqFt;
      dataObj.sqftPercDiff = calculateDiff(
        currentYearObjArea.AvgPricePerSqFt,
        pastYearObjArea.AvgPricePerSqFt,
      );

      return dataObj;
    } else if (
      current180DaysUnitsSold < 1 ||
      +previous180DaysUnitsSold < 1 ||
      use12MonthComparison
    ) {
      // 1Year Trending" and "Past 1 Year Trending"

      const {
        marketTrends: marketTrendsArea,
        marketTrendsPercentage: marketTrendsPercArea,
        graphAverages: graphAveragesArea,
      } = quarterlyAreaTable;

      let currentYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "1-Year Trending",
      )[0];

      // let currentYearObjArea = marketTrendsArea.filter(
      //   (obj) => obj.TrendName === "1 Year Trends Percentage"
      // )[0];

      let currentYearAreaPerc = marketTrendsPercArea.filter(
        (obj) => obj.TrendPercentageName === "1 Year Trends Percentage",
      )[0];

      const pastYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "Past 1-Year Trending",
      )[0];

      dataObj.compareDays = "12 Months";
      dataObj.monthComparison = 12;
      dataObj.salePriceDataPoint = dataObj.useMedianSalePrice
        ? last12MonthsMedianSalePrice
        : currentYearObjArea.AvgSalePrice;
      dataObj.salePriceDiff = dataObj.useMedianSalePrice
        ? median12MonthsPercentage
        : currentYearAreaPerc.PercentageAvgSalePrice;
      dataObj.daysToSellDataPoint = currentYearObjArea.AvgDaysOnMarket;
      dataObj.receivedDataPoint = currentYearObjArea.AvgPercentOfReceiving;
      dataObj.receivedPerc = calculateDiff(
        currentYearObjArea.AvgPercentOfReceiving,
        pastYearObjArea.AvgPercentOfReceiving,
      );

      dataObj.daysToSellPerc = currentYearAreaPerc.PercentageAvgDaysOnMarket;

      dataObj.unitsSoldDataPoint = currentYearObjArea.HomesSold;
      dataObj.previousUnitsSoldDataPoint = pastYearObjArea.HomesSold;
      dataObj.unitsSoldPerc = currentYearAreaPerc.PercentageNumberOfHomesSold;

      dataObj.sqftDataPoint = last12MonthsPricePerSqFt;
      dataObj.sqftPercDiff = calculateDiff(
        last12MonthsPricePerSqFt,
        previous12MonthsPricePerSqFt,
      );

      return dataObj;
    } else if (
      use6Months ||
      +current90DaysUnitsSold < 1 ||
      +previous90DaysUnitsSold < 1 ||
      mlsAreaID === "156" ||
      mlsAreaID === "SBA-20FRes"
    ) {
      dataObj.compareDays = "6 Months";
      dataObj.monthComparison = 6;
      dataObj.salePriceDataPoint = current180DaysAvgSalePrice;
      dataObj.salePriceDiff = calculateDiff(
        current180DaysAvgSalePrice,
        previous180DaysAvgSalePrice,
      );
      dataObj.receivedDataPoint = current180DaysPercentReceivedOfAsking;
      dataObj.receivedPerc = calculateDiff(
        current180DaysPercentReceivedOfAsking,
        previous180DaysPercentReceivedOfAsking,
      );
      dataObj.sqftDataPoint = current180DaysPricePerSqFt;
      dataObj.sqftPercDiff = calculateDiff(
        current180DaysPricePerSqFt,
        previous180DaysPricePerSqFt,
      );
      dataObj.daysToSellDataPoint = current180DaysAvgDOM;
      dataObj.daysToSellPerc = calculateDiff(
        current180DaysAvgDOM,
        previous180DaysAvgDOM,
      );
      dataObj.unitsSoldDataPoint = current180DaysUnitsSold;
      dataObj.previousUnitsSoldDataPoint = previous180DaysUnitsSold;
      dataObj.unitsSoldPerc = calculateDiff(
        current180DaysUnitsSold,
        previous180DaysUnitsSold,
      );

      return dataObj;
    } else {
      dataObj.compareDays = "90 Days";
      dataObj.monthComparison = 6;
      dataObj.salePriceDataPoint = current90DaysAvgSalePrice;
      dataObj.salePriceDiff = calculateDiff(
        current90DaysAvgSalePrice,
        previous90DaysAvgSalePrice,
      );
      dataObj.receivedDataPoint = current90DaysPercentReceivedOfAsking;
      dataObj.receivedPerc = calculateDiff(
        current90DaysPercentReceivedOfAsking,
        previous90DaysPercentReceivedOfAsking,
      );

      dataObj.sqftDataPoint = current90DaysPricePerSqFt;
      dataObj.sqftPercDiff = calculateDiff(
        current90DaysPricePerSqFt,
        previous90DaysPricePerSqFt,
      );

      dataObj.daysToSellDataPoint = current90DaysAvgDOM;
      dataObj.daysToSellPerc = calculateDiff(
        current90DaysAvgDOM,
        previous90DaysAvgDOM,
      );
      dataObj.unitsSoldDataPoint = current90DaysUnitsSold;
      dataObj.previousUnitsSoldDataPoint = previous90DaysUnitsSold;
      dataObj.unitsSoldPerc = calculateDiff(
        current90DaysUnitsSold,
        previous90DaysUnitsSold,
      );

      return dataObj;
    }
  };

  render() {
    const {
      current90DaysAvgSalePrice,
      previous90DaysAvgSalePrice,
      current90DaysAvgDOM,
      previous90DaysAvgDOM,
      current90DaysPricePerSqFt,
      previous90DaysPricePerSqFt,
      current90DaysUnitsSold,
      previous90DaysUnitsSold,
    } = this.props.quarterlyAreaTable.marketHighLightsData;
    const {
      currentArea,
      printVersion,
      useSecondMarketIndicators,
      from3rdPage,
      useSeparatedPropertyTypesCondos,
      useSeparatedPropertyTypesTownhouses,
      useSeparatedPropertyTypesCondoTownhouse,
    } = this.props;
    const { mlsAreaID } = currentArea;
    const { infinityCheck } = propertyUtil;

    const determineComparison = this.determineComparison();
    let marketIndicatorsStyles;
    if (mlsAreaID === "xSMA-390") {
      marketIndicatorsStyles =
        "third-page-market-indicators second-page-bottom-market-indicators";
    } else if (
      (mlsAreaID === "SMA-392" && from3rdPage) ||
      (mlsAreaID === "CCA-4500F" && from3rdPage)
    ) {
      marketIndicatorsStyles = "third-page-market-indicators";
    } else if (
      (mlsAreaID === "SMA-392" && !useSecondMarketIndicators) ||
      (mlsAreaID === "CCA-4500F" && !useSecondMarketIndicators)
    ) {
      marketIndicatorsStyles =
        "first-table-special-market-indicators double-tables-market-indicators";
    } else if (mlsAreaID === "SMA-392" || mlsAreaID === "CCA-4500F") {
      marketIndicatorsStyles = "double-tables-market-indicators";
    }
    console.log("this.props", this.props);
    return (
      <div
        className={`${
          printVersion
            ? `print-ye2-market-indicators ${marketIndicatorsStyles}`
            : `editor-ye2-market-indicators ${marketIndicatorsStyles}`
        }`}
      >
        {/*<div className="market-indicators-footer">
          <div className="market-indicators-footer-row">
            <p
              className={`market-indicators-footer-compare ${
                determineComparison.compareDays === "6 Months"
                  ? "six-month-indicator"
                  : determineComparison.compareDays === "12 Months"
                  ? "twelve-month-indicator"
                  : ""
              }`}
            >
              Last {determineComparison.compareDays}:
            </p>
            <p>
              {determineComparison.unitsSoldDataPoint}{" "}
              {determineComparison.unitsSoldDataPoint === "1"
                ? "Unit"
                : "Units"}{" "}
              Sold
            </p>
          </div>
          <div className="market-indicators-footer-row">
            <p
              className={`market-indicators-footer-compare ${
                determineComparison.compareDays === "6 Months"
                  ? "six-month-indicator"
                  : determineComparison.compareDays === "12 Months"
                  ? "twelve-month-indicator"
                  : ""
              }`}
            >
              Previous {determineComparison.compareDays}:{" "}
            </p>
            <p>
              {determineComparison.previousUnitsSoldDataPoint}{" "}
              {determineComparison.previousUnitsSoldDataPoint === "1"
                ? "Unit"
                : "Units"}{" "}
              Sold
            </p>
          </div>
        </div>*/}
        <div className="mini-market-title">
          {useSeparatedPropertyTypesTownhouses ? (
            <div className="left-market-title-container">
              <div className="second-market-indicators-title">Townhouses</div>
              <div className="left-market-title-section">
                <p>Key Market Averages</p>
              </div>
            </div>
          ) : useSeparatedPropertyTypesCondos ? (
            <div className="left-market-title-container">
              <div className="second-market-indicators-title">Condominiums</div>
              <div className="left-market-title-section">
                <p>Key Market Averages</p>
              </div>
            </div>
          ) : useSeparatedPropertyTypesCondoTownhouse ||
            (useSecondMarketIndicators &&
              from3rdPage &&
              mlsAreaID !== "SMA-392") ? (
            <div className="left-market-title-container">
              <div className="second-market-indicators-title">
                Condos/Townhouses
              </div>
              <div className="left-market-title-section">
                <p>Key Market Averages</p>
              </div>
            </div>
          ) : mlsAreaID === "SMA-392" ? (
            <div className="left-market-title-container">
              <div className="second-market-indicators-title">
                Single Family Homes
              </div>
              <div className="left-market-title-section">
                <p>Key Market Averages</p>
              </div>
            </div>
          ) : (
            <div className="left-market-title-container">
              <div className="left-market-title-section">
                <p>Key Market Averages</p>
              </div>
            </div>
          )}

          {determineComparison.compareDays === "6MonthsVSLastYear6Months" ? (
            <div className="same-6-month-last-year">
              <p>Last 6 Months</p>
              <p className="lc-market-title">vs</p>
              <p>Same 6 Months Last Year</p>
            </div>
          ) : (
            <div
              className={`right-market-title-section ${
                (determineComparison.compareDays === "6 Months" ||
                  determineComparison.compareDays === "12 Months") &&
                "smaller-market-title-section"
              }`}
            >
              <p>Last {determineComparison.compareDays}</p>
              <p className="lc-market-title">vs</p>
              <p> Previous {determineComparison.compareDays}</p>
            </div>
          )}
        </div>
        <div className="mini-market-title-divider"></div>
        <div className="indicator-container">
          <div className="inner-indicator-container">
            <IndicatorSection
              category="Sale Prices"
              useMedianSalePrice={determineComparison.useMedianSalePrice}
              value={determineComparison.salePriceDataPoint}
              perc={determineComparison.salePriceDiff}
              currentArea={currentArea}
            />
            <IndicatorSection
              category="Square Ft"
              value={determineComparison.sqftDataPoint}
              perc={determineComparison.sqftPercDiff}
              currentArea={currentArea}
            />
            <IndicatorSection
              category="% Received of Asking"
              value={determineComparison.receivedDataPoint}
              perc={determineComparison.receivedPerc}
              currentArea={currentArea}
            />
            {mlsAreaID !== "SMA-420" && (
              <IndicatorSection
                category="Days to Sell"
                value={determineComparison.daysToSellDataPoint}
                perc={determineComparison.daysToSellPerc}
                currentArea={currentArea}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default YETwoMarketIndicators;
